module.exports = __webpack_public_path__ + "static/js/0.37e00f03.chunk.worker.js"